import { Component, OnInit } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { ProfessionalService } from 'app/services/professional.service';
import moment from 'moment';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'contacts-inactives-banner',
	templateUrl: './contacts-inactives-banner.component.html',
	styleUrls: ['./contacts-inactives-banner.component.scss'],
})
export class ContactsInactivesBannerComponent implements OnInit {
	public showBanner = false;
	public totalInactiveCustomers = 0;
	public sendMessagesModal = false;
	public inactiveContacts: string[];
	public inactiveMessage = '';
	constructor(
		public atService: ActionTrackerService,
		public professionalService: ProfessionalService
	) {}

	ngOnInit(): void {
		this.fecthInactiveCustomers();
	}

	fecthInactiveCustomers() {
		const dateOfSendedLastMessage = localStorage.getItem(
			'sended-inactive-customers-bulk-message'
		);
		if (
			dateOfSendedLastMessage &&
			moment(new Date()).diff(dateOfSendedLastMessage, 'day') < 30
		) {
			return;
		}

		const dateOfLastCloseBanner = localStorage.getItem(
			'closed-inactive-customers-banner'
		);
		if (
			dateOfLastCloseBanner &&
			moment(new Date()).diff(dateOfLastCloseBanner, 'day') < 1
		) {
			return;
		}

		forkJoin([
			this.professionalService.getContactsInactive(),
			this.professionalService.loadMessage(),
		]).subscribe(([contacts, message]) => {
			const total = contacts.length;
			const contactsList = contacts;

			if (total < 1) return;

			this.totalInactiveCustomers = total;
			this.inactiveContacts = contactsList.map((contact) => contact.refUserId);
			this.inactiveMessage = this.formatMessage(message.message);
			return this.openBanner();
		});
	}

	closeBanner(onlyCloseBanner?: boolean) {
		this.showBanner = false;
		this.atService.eventTracker(
			SCOPE_TYPE.InactiveCustomers,
			SUBSCOPE_TYPE.Banner,
			ITEM_TYPE.CloseBtn,
			INTERACTION_TYPE.Click,
			{}
		);
		if (onlyCloseBanner) {
			return;
		}

		localStorage.setItem(
			'closed-inactive-customers-banner',
			new Date().toISOString()
		);
	}

	openBanner() {
		this.showBanner = true;
		this.atService.eventTracker(
			SCOPE_TYPE.InactiveCustomers,
			SUBSCOPE_TYPE.Banner,
			ITEM_TYPE.InactiveCustomersBanner,
			INTERACTION_TYPE.Seen,
			{}
		);
	}

	sendMessage() {
		this.sendMessagesModal = true;
		this.atService.eventTracker(
			SCOPE_TYPE.InactiveCustomers,
			SUBSCOPE_TYPE.Banner,
			ITEM_TYPE.SendMessageBtn,
			INTERACTION_TYPE.Click,
			{}
		);
	}

	closeBulkMessageModal(event: { messageSended?: boolean }) {
		this.sendMessagesModal = false;
		if (event.messageSended) {
			this.closeBanner(true);
		}
	}

	setSendedMessageInLocalStorage(): void {
		localStorage.setItem(
			'sended-inactive-customers-bulk-message',
			new Date().toISOString()
		);
	}

	formatMessage(message: string): string {
		return message
			.replace(/{{clientName}}/g, '{{nome_do_cliente}}')
			.replace(/{{proLink}}/g, '{{link_página_profissional}}')
			.replace(/{{proName}}/g, '{{nome_do_profissional}}');
	}
}
